<script lang="ts">
	import { Models as M } from "@lux-ai/api-interface"
	import { PROJECTOR_COLOR_OPTIONS } from "luxedo-data"
	import { FilterIcon } from "luxedo-icons"
	import { QuickSelectPointer, Tag } from "misc-ui"

	interface Props {
		allTags: Array<M.ThemeTag>
		selectedTags: Array<M.ThemeTag>
		onSelect: (tag: M.ThemeTag) => void
		onDeselect: (tag: M.ThemeTag) => void
	}

	let { allTags, selectedTags, onDeselect, onSelect }: Props = $props()

	let isOpen: boolean = $state(false)
	let tagContainer: HTMLDivElement = $state()

	function toggleOpen() {
		isOpen = !isOpen
	}

	function handlePointerDown(
		e: PointerEvent & {
			currentTarget: EventTarget & Document
		},
	) {
		if (!isOpen) return
		if (!tagContainer) return
		if (!(e.target instanceof Node)) return

		if (!tagContainer.contains(e.target)) {
			e.stopPropagation()
			isOpen = false
		}
	}
</script>

<div class="tag-filter-container" bind:this={tagContainer}>
	<button class="icon" onclick={toggleOpen}><FilterIcon /></button>
	{#if isOpen}
		<QuickSelectPointer />
		<div class="tag-filter">
			{#each allTags as tag, i}
				<Tag
					color={`#${PROJECTOR_COLOR_OPTIONS[i % PROJECTOR_COLOR_OPTIONS.length]}`}
					{tag}
					isSelected={selectedTags.includes(tag)}
					onclick={() => {
						if (selectedTags.includes(tag)) onDeselect(tag)
						else onSelect(tag)
					}}
				/>
			{/each}
		</div>
	{/if}
</div>

<svelte:document onpointerdown={handlePointerDown} />

<style>
	.tag-filter-container {
		position: relative;
	}

	.tag-filter {
		background-color: var(--color-bg-opaque);
		position: absolute;
		max-height: 50vh;
		overflow-y: auto;
		right: -50%;
		padding: 0.5rem;
		border-radius: var(--br);
	}

	.tag-filter-container :global(.quick-select-pointer) {
		position: absolute;
		bottom: 0;
		right: 0;
		transform: rotate(90deg) translateX(1px) translateY(0.8rem);
	}

	.icon :global(.svg-fill) {
		fill: var(--color-text);
	}

	.icon:hover :global(.svg-fill),
	.icon:focus-visible :global(.svg-fill) {
		fill: var(--color-main);
	}
</style>
